export const CHARGE_SOURCES = ['INVOICE_DEPOSIT', 'WITHDRAWAL', 'WHITELIST', 'REFUND'] as const;

export const chargeSourceKey = (source: string): string =>
  (CHARGE_SOURCES as readonly string[]).includes(source) ? `amlBilling.source.${source}` : 'amlBilling.source.unknown';

export const chargeStatusKey = (status: string, statusReason: string | null | undefined): string => {
  if (status === 'WAIVED' && statusReason === 'FREE_QUOTA') return 'amlBilling.status.freeQuota';
  if (status === 'ACCRUED' || status === 'INVOICED' || status === 'WAIVED') return `amlBilling.status.${status}`;
  return 'amlBilling.status.unknown';
};

export const sumDecimalStrings = (values: string[]): string => {
  const scale = 8;
  const total = values.reduce((sum, value) => {
    const negative = value.trim().startsWith('-');
    const [whole, fraction = ''] = value.trim().replace('-', '').split('.');
    const digits = `${whole || '0'}${fraction.padEnd(scale, '0').slice(0, scale)}`;
    const parsed = Number(digits);
    if (!Number.isSafeInteger(parsed)) return sum;
    return sum + (negative ? -parsed : parsed);
  }, 0);
  const sign = total < 0 ? '-' : '';
  const absolute = Math.abs(total).toString().padStart(scale + 1, '0');
  const head = absolute.slice(0, -scale);
  const tail = absolute.slice(-scale).replace(/0+$/, '');
  return tail ? `${sign}${head}.${tail}` : `${sign}${head}`;
};

export const currentUtcMonth = (date = new Date()): string => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export const isClosedMonth = (month: string, now = new Date()): boolean => month < currentUtcMonth(now);
